import { Children, cloneElement, isValidElement, type ReactElement } from 'react';
import styles from './stepper.module.css';
import type { StepProps } from './step/step';

export interface StepperProps {
  currentStep: number;
  children: (ReactElement<StepProps> | null)[];
  onStepClick?: (stepIndex: number) => void;
  lastCompletedStep?: number;
}

export function Stepper({
  currentStep,
  children,
  onStepClick,
  lastCompletedStep,
}: StepperProps): ReactElement {
  const maxChildrenArray = Children.toArray(children).slice(0, 6);
  const totalSteps = maxChildrenArray.length;

  return (
    <div className={styles.stepperContainer}>
      <ol className={styles.stepperContent}>
        {maxChildrenArray.map((child, index) => {
          if (!isValidElement<StepProps>(child)) return null;

          return cloneElement(child, {
            key: child.key,
            stepIndex: index,
            totalSteps,
            isActive: index === currentStep,
            isComplete: index <= Math.max(currentStep, (lastCompletedStep ?? -1) + 1),
            onClick: onStepClick,
          });
        })}
      </ol>
    </div>
  );
}
